import {Drawing} from '@domain/production-schedule/drawing';
import {PathLabelDrawing} from '@domain/production-schedule/path-label-drawing';
import {ColoredYarnSetPosition} from '@domain/textile-data/creel/colored-yarn-set-position';
import {OverviewListColoredYarnSetWithStartDent} from '@domain/textile-data/creel/overview-list-colored-yarn-set-with-start-dent';
import {LoadingState} from '@presentation/pages/texfab/production-schedule/add/plan/loading-state';
import {isEqual, isNil} from 'lodash-es';

export interface CachedPathLabelDrawingReference {
  drawing: PathLabelDrawing;
  state: LoadingState;
}

export class ProductionSchedulePathLabelDrawingsCache {
  public readonly pathlabelDrawingsMap: Map<string, CachedPathLabelDrawingReference> = new Map<string, CachedPathLabelDrawingReference>();

  public hasPathLabelDrawingBeenLoaded(drawing: Drawing, coloredYarnSetWithStartDent: OverviewListColoredYarnSetWithStartDent): boolean {
    const cachedPathLabelDrawingReference = this.getPathLabelDrawingCachedReference(drawing, coloredYarnSetWithStartDent);

    return !isNil(cachedPathLabelDrawingReference) && isEqual(cachedPathLabelDrawingReference.state, LoadingState.DONE);
  }

  public getPathLabelDrawingCachedReference(drawing: Drawing, coloredYarnSetWithStartDent: OverviewListColoredYarnSetWithStartDent): CachedPathLabelDrawingReference {
    return this.pathlabelDrawingsMap.get(this.getRecoloredPathLabelDrawingReferenceId(drawing, coloredYarnSetWithStartDent));
  }

  public add(cachedPathLabelDrawingReference: CachedPathLabelDrawingReference, coloredYarnSetWithStartDent: OverviewListColoredYarnSetWithStartDent): void {
    this.pathlabelDrawingsMap.set(this.getRecoloredPathLabelDrawingReferenceId(cachedPathLabelDrawingReference.drawing, coloredYarnSetWithStartDent), cachedPathLabelDrawingReference);
  }

  public clearNonLoadedPathLabelDrawings(): void {
    this.pathlabelDrawingsMap.forEach((value: CachedPathLabelDrawingReference, key: string) => {
      if (isEqual(value.state, LoadingState.BUSY)) {
        this.pathlabelDrawingsMap.delete(key);
      }
    });
  }

  private getRecoloredPathLabelDrawingReferenceId(drawing: PathLabelDrawing, {coloredYarnSet, position}: OverviewListColoredYarnSetWithStartDent): string {
    return `${drawing.image.id}_${coloredYarnSet.id}_${ColoredYarnSetPosition[position]}`;
  }
}
